import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { CourseLanguageDto } from "./getCourseLanguages";

export async function getCourseLanguageById(
  id: number | string
): Promise<CourseLanguageDto | void> {
  const localApi = await getLocalApi();
  const url = (apiConfig as any).reference_data_course_language_by_id.replace(
    "{languageId}",
    String(id)
  );
  return await localApi.fetchSingle(
    url,
    (dto: any) => ({
      id: typeof dto?.id === "number" ? dto.id : Number(dto?.id) || 0,
      name: dto?.name ?? "",
      createdBy: dto?.createdBy ?? "",
      lastModifiedBy: dto?.lastModifiedBy ?? "",
      active: typeof dto?.isActive === "boolean" ? dto.isActive : !!dto?.active,
    }),
    "Failed to fetch course language by id"
  );
}